import gql from "graphql-tag";

const COMMON_QUERY = `
id
title
code
updatedAt
createdAt
`;

const queryCreate = gql`
  mutation(
    $title: String!
    $code: String!
    ) {
    createParcelType(data: {
      title: $title
      code: $code
     }) {
      ${COMMON_QUERY}
    }
  }
`;

const queryUpdate = gql`
  mutation($id: ID!,
    $title: String
    $code: String
    ) {
    updateParcelType(id: $id, data: {
      title: $title
      code: $code

    }) {
      ${COMMON_QUERY}
    }
  }
`;

const queryDelete = gql`
  mutation($id: ID!) {
    deleteParcelType(id: $id) {
      id
    }
  }
`;

const queryGetAll = gql`
  query($query: String, $limit: Int, $page: Int) {
    getAllParcelType(
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      ${COMMON_QUERY}
     
    }
  }
`;

const queryGet = gql`
  query($id: ID!) {
    getParcelType(id: $id) {
      ${COMMON_QUERY}
      author {
        id
        fullname
      }
    }
  }
`;

export default {
  queryCreate,
  queryUpdate,
  queryDelete,
  queryGetAll,
  queryGet,
};
